/**
 * 契約会社の1人あたり作業時間（時間）
 */
export const CONTRACT_COMPANY_HOURS_PER_WORKER = 8;

/**
 * APIレスポンスのレコードを表示用にマッピングする。
 * 契約会社レコードの場合、totalHours はフロントエンドで workerCount × 8 として計算する（issue #858 要件）。
 */
export function mapWorkRecord(record) {
  const workerCount = Math.max(Number(record.workerCount) || 0, 0);
  const isContractCompany = !!(record.contractCompany && record.contractCompany.id);
  return {
    ...record,
    contractCompanyName: isContractCompany ? (record.contractCompany.name || '-') : '-',
    totalHours: isContractCompany
      ? workerCount * CONTRACT_COMPANY_HOURS_PER_WORKER
      : record.totalHours,
    hasContractCompany: isContractCompany
  };
}
